import {Component, Input, OnInit} from '@angular/core';
import {QRCode} from "../../../../models/QRCode";
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
  selector: 'app-qr-enlarge',
  templateUrl: './qr-enlarge.component.html',
  styleUrls: ['./qr-enlarge.component.scss']
})
export class QrEnlargeComponent implements OnInit {

  @Input() type!: 'event' | 'campaign';
  @Input() typeID!: string | undefined;
  @Input() code: QRCode | undefined;
  @Input() imagePath: string = '';

  constructor(private modal: NzModalRef) { }

  ngOnInit(): void {
  }

  destroyModal(): void {
    this.modal.destroy();
  }

}
